<div class="admin-page-container">
  <div class="page-header">
    <div class="header-left">
      <h1>Department Master</h1>
      <p>Configure and manage all government departments in the system</p>
    </div>
    <div class="header-right">
      <button class="btn-primary" (click)="openCreateModal()">
        <i class="fa-solid fa-building-circle-plus"></i>
        <span>Add Department</span>
      </button>
    </div>
  </div>

  <div class="dashboard-stats-row">
    <div class="stat-card">
      <div class="stat-icon bg-blue"><i class="fa-solid fa-building"></i></div>
      <div class="stat-info">
        <span class="label">Total Depts</span>
        <span class="value">{{ departments().length }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-green"><i class="fa-solid fa-circle-check"></i></div>
      <div class="stat-info">
        <span class="label">Active</span>
        <span class="value">{{ totalActive() }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-orange"><i class="fa-solid fa-circle-minus"></i></div>
      <div class="stat-info">
        <span class="label">Inactive</span>
        <span class="value">{{ totalInactive() }}</span>
      </div>
    </div>
  </div>

  <app-data-table
    [title]="'Department Master List'"
    [data]="departments()"
    [columns]="columns"
    [loading]="loading()"
    (action)="handleTableAction($event)"
  ></app-data-table>
</div>

<!-- Create/Edit Dept Modal -->
<app-admin-modal
  [isOpen]="isModalOpen()"
  [title]="editingDept ? 'Edit Department' : 'Add Department'"
  [subtitle]="editingDept ? 'Modify department name and details' : 'Register a new department in the master list'"
  [icon]="editingDept ? 'fa-solid fa-building-pen' : 'fa-solid fa-building-circle-plus'"
  [submitText]="editingDept ? 'Update Dept' : 'Create Dept'"
  [isSubmitting]="isSubmitting()"
  (close)="isModalOpen.set(false)"
  (submit)="submitForm()"
>
  <form [formGroup]="deptForm" class="admin-form">
    <div class="form-grid">
      <div class="form-group full">
        <label>Department Name</label>
        <div class="input-wrap">
          <i class="fa-solid fa-building"></i>
          <input type="text" formControlName="name" placeholder="e.g. Water Resources Department">
        </div>
        <p class="field-hint" *ngIf="deptForm.get('name')?.invalid && deptForm.get('name')?.touched">
          Please enter a valid department name (min 3 chars).
        </p>
      </div>

      <div class="form-group full" *ngIf="editingDept">
        <label class="toggle-wrap">
          <span>Active Status</span>
          <input type="checkbox" formControlName="isActive">
          <span class="slider"></span>
        </label>
      </div>
    </div>
  </form>

  <!-- History section (simplified) -->
  <div class="history-section" *ngIf="editingDept?.history?.length">
    <h4><i class="fa-solid fa-clock-rotate-left"></i> Recent History</h4>
    <div class="history-list">
      <div class="history-item" *ngFor="let entry of editingDept?.history">
        <div class="h-dot"></div>
        <div class="h-info">
          <span class="h-action">{{ entry.action }}</span>
          <span class="h-details">{{ entry.details }}</span>
          <span class="h-time">{{ entry.timestamp | date:'short' }}</span>
        </div>
      </div>
    </div>
  </div>
</app-admin-modal>
